import { AppModule } from './app/app.module';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { preloadGoogleLocationServices } from './app/core/utils/place-geocode-cache.util';
import { ensureGoogleMapsLoaded } from './app/core/utils/google-maps-loader.util';

if (environment.production) {
  enableProdMode();
}

void ensureGoogleMapsLoaded()
  .then((loaded) => {
    if (!loaded) {
      // Not a reason to keep the member waiting: the application starts, and
      // the screens that need Maps ask for it again when they open.
      console.warn('Google Maps did not load, continuing without maps');
      return;
    }
    preloadGoogleLocationServices();
  })
  .finally(() =>
    platformBrowserDynamic()
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
      .catch((err) => console.error('Failed to bootstrap application', err)),
  );
